module.exports = __webpack_public_path__ + "static/hoverBg-5f42ce23173e1f9d1457bf0c7aae4ac8.png";